﻿
export function correctDates(data: any): any {
  if (typeof data !== "string") {
  for (let key in data) {
    if (data[key] && typeof data[key] === "object")
      data[key] = correctDates(data[key]);
    else if (data[key] && dateISO.test(data[key].toString())) {
      let x = (Date as any).fromString(data[key]);
      data[key] = new Date(x.getTime() + (x.getTimezoneOffset() * 60000));
    }
  }
}
  return data;
}

var dateISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*/i;

(function () {

  var d = window.Date as any;
  var regexIso8601 = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z)?$/;


  d._myparse = function (v) {

    if (v.charAt(v.length - 1) !== "Z")
      v += "Z";
    var m = regexIso8601.exec(v);

    if (m) {
      return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt((+m[10]) * 1000 as any) || 0));
    }

    return d.parse.apply(this, arguments);
  };


  d.fromString = function (v) {
    return d._myparse(v);
  };

})();
